import { bookingStatus } from 'types/booking';

const { CANCELLED, TEMPORARILY_CANCELLED, IN_AFTERSALES, REFUNDED, PENDING_REFUND, EXPIRED_ON_HOLD } = bookingStatus;

export const BUSY_STATES = [CANCELLED, TEMPORARILY_CANCELLED, IN_AFTERSALES, REFUNDED, PENDING_REFUND, EXPIRED_ON_HOLD];
